export default "__VITE_ASSET__ebfd8298__"